/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";
import {
  IWithinRangeIntegerTag,
  WithinRangeInteger
} from "@pagopa/ts-commons/lib/numbers";

// required attributes
const PddR = t.interface({
  description: t.string,

  enabled: t.boolean,

  id_pdd: t.string,

  ip: t.string
});

// optional attributes
const PddO = t.partial({
  port: t.union([
    WithinRangeInteger<1, 65535, IWithinRangeIntegerTag<1, 65535>>(1, 65535),
    t.literal(65535)
  ])
});

export const Pdd = t.intersection([PddR, PddO], "Pdd");

export type Pdd = t.TypeOf<typeof Pdd>;
